export const ReportStatus = {
    Pending: 'Pending',
    Declined: 'Declined',
    Approved: 'Approved'
}